import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
const AsciiSpinner = (param)=>{
    let { ms = 100, chars = [
        "&#9719;",
        "&#9718;",
        "&#9717;",
        "&#9716;"
    ] } = param;
    const [i, setI] = useState(1);
    useEffect(()=>{
        const interval = setInterval(()=>{
            setI(i + 1);
        }, ms);
        return ()=>clearInterval(interval);
    }, [
        i
    ]);
    return /*#__PURE__*/ _jsx("span", {
        dangerouslySetInnerHTML: {
            __html: chars[i % 4]
        }
    });
};
export { AsciiSpinner };
